/* eslint camelcase: ["error", {properties: "never"}]*/
import React, {
  forwardRef,
  ReactElement,
  useState,
  useEffect,
  useRef,
  useReducer
} from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import MaterialTable, { Icons } from 'material-table';
import { Clear, Search, ArrowDownward, PhotoCamera } from '@material-ui/icons';
import {
  makeStyles,
  Button,
  DialogContent,
  DialogActions,
  Link,
  TextField,
  Dialog,
  useMediaQuery,
  useTheme,
  TextFieldProps,
  IconButton
} from '@material-ui/core';

import {
  getAllPhysicians,
  createPhysician,
  updatePhysician,
  deletePhysician,
  getPhysician
} from '../../../../shared/src/services/PhysicianService';
import { _snackbarAcknowledgement } from '../../../../shared/src/store/actions/AuthActions';

import AuthUtils from '../../utils/AuthUtils';
import DeleteImage from '../../assets/images/trash.png';

import './InterpretingPhysicians.scss';

const InterpretingPhysicians = (props: any): ReactElement => {
  const useStyles = makeStyles(() => ({
    root: {
      '& .MuiToolbar-regular': {
        minHeight: 0
      },
      '& .MuiOutlinedInput-root': {
        border: 0
      }
    },
    button: {
      background: '#F7931E',
      borderRadius: 8,
      width: '6.1vw',
      height: '55%',
      textAlign: 'center',
      justifyContent: 'ceter',
      alignItems: 'center',
      textTransform: 'none',
      float: 'right'
    },
    saveButton: {
      background: '#F7931E',
      borderRadius: 8,
      width: 95,
      height: 45,
      textAlign: 'center',
      justifyContent: 'ceter',
      alignItems: 'center',
      textTransform: 'none',
      float: 'right'
    },
    input: {
      color: '#000000',
      fontFamily: 'hindGunturRegular',
      fontSize: '1.1vw',
      height: 60,
      paddingTop: 30,
      borderRadius: 2
    },
    textAreaInput: {
      color: '#161719',
      fontFamily: 'hindGunturMedium',
      fontSize: '1vw',
      borderRadius: 2
    },
    dialog: {
      '& .MuiDialog-paperScrollPaper': {
        borderRadius: 8,
        boxShadow: '0 10px 30px 0 rgba(0, 0, 0, 0.05)'
      }
    }
  }));

  const columnsList: any = [
    {
      title: 'NAME',
      field: 'name',
      cellStyle: { textAlign: 'left', paddingRight: '2%' },
      headerStyle: { textAlign: 'left' }
    },
    {
      title: 'READER ID',
      field: 'readerId',
      cellStyle: { textAlign: 'right', width: '13%', paddingRight: '2%' },
      headerStyle: { textAlign: 'right' }
    }
  ];

  const optionsObject: any = {
    search: true,
    paging: false,
    header: true,
    showTitle: false,
    sorting: true,
    searchAutoFocus: true,
    searchFieldStyle: {
      marginTop: '-5vw',
      width: '22vw',
      height: '3.2vw',
      border: '1px solid #D0D0D0',
      borderRadius: 3,
      backgroundColor: '#FFFFFF',
      paddingTop: 4,
      paddingLeft: '5%',
      marginRight: '7vw'
    },
    headerStyle: {
      color: '#777B7E',
      fontFamily: 'workSansSemiBold',
      height: '3vw',
      fontSize: '0.75vw'
    }
  };

  const styleObject: any = {
    width: '96%',
    fontFamily: 'hindGunturMedium',
    fontSize: '0.9vw'
  };

  const tableIcons: Icons = {
    ResetSearch: forwardRef((prop, ref) => <Clear {...prop} ref={ref} />),
    Search: forwardRef((prop, ref) => <Search {...prop} ref={ref} />),
    SortArrow: forwardRef((prop, ref) => <ArrowDownward {...prop} ref={ref} />)
  };

  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const firstNameRef: any = useRef<TextFieldProps>(null);
  const lastNameRef: any = useRef<TextFieldProps>(null);
  const readerIdRef: any = useRef<TextFieldProps>(null);
  const bioRef: any = useRef<TextFieldProps>(null);

  const userObject: any = AuthUtils.getUser();
  const userId: any = userObject.id;

  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [physiciansData, setPhysiciansData]: any = useState([]);
  const [choosenOperation, setChoosenOperation]: any = useState('');
  const [selectedObjectId, setSelectedObjectId]: any = useState();
  const [selectedDataObject, setSelectedDataObject]: any = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      firstName: '',
      lastName: '',
      bio: '',
      profilePic: '',
      readerId: null
    }
  );

  const processPhysicianData = (response: any): void => {
    const values: any = [];

    response.forEach((element: any) => {
      const object: any = {
        name: element.first_name + ' ' + element.last_name,
        id: element.id,
        readerId: element.reader_id
      };
      values.push(object);
    });
    setPhysiciansData(values);
  };

  const fetchPhysiciansInformation = async (): Promise<void> => {
    try {
      const response = await getAllPhysicians();
      if (response && response.result && response.result.length > 0) {
        processPhysicianData(response.result);
      } else {
        setPhysiciansData([]);
      }
    } catch (error) {
      props._snackbarAcknowledgement(
        true,
        t('COMMON.GETERROR'),
        t('COMMON.ERRORTEXT')
      );
    }
  };

  useEffect(() => {
    fetchPhysiciansInformation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const openDialog = () => {
    setIsDialogVisible(true);
    setChoosenOperation(t('COMMON.ADD'));
  };

  const clearSelectedObject = () => {
    const object = selectedDataObject;
    object.firstName = '';
    object.lastName = '';
    object.bio = '';
    object.profilePic = '';
    object.readerId = null;
    setSelectedDataObject(object);
  };

  const closeDialog = () => {
    setIsDialogVisible(false);
    setSelectedObjectId();
    setChoosenOperation();
    clearSelectedObject();
  };

  const handleRowClick = async (event: any, rowData: any) => {

    const physicianData = await getPhysician(rowData.readerId);
    if (physicianData && physicianData?.result) {
      const object = selectedDataObject;
      object.firstName = physicianData.result.first_name;
      object.lastName = physicianData.result.last_name;
      object.bio = physicianData.result.bio;
      object.profilePic = physicianData.result.profile_pic;
      object.readerId = physicianData.result.reader_id
      setSelectedDataObject(object);
      setIsDialogVisible(true);
      setChoosenOperation(t('COMMON.EDIT'));
      setSelectedObjectId(physicianData.result.id);
    }
  };

  const uploadFile = (e: any): void => {
    e.preventDefault();
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const object = selectedDataObject;
      object.profilePic = reader.result;
      setSelectedDataObject(object);
    };
  };

  const createOrUpdateData = async (): Promise<void> => {
    try {
      const object: any = {
        first_name: firstNameRef.current.value,
        last_name: lastNameRef.current.value,
        bio: bioRef.current.value,
        profile_pic: selectedDataObject.profilePic,
        reader_id: readerIdRef.current.value
      };
      let response = null;
      if (choosenOperation === t('COMMON.ADD')) {
        response = await createPhysician(userId, object);

        if (response.result) {
          fetchPhysiciansInformation();
        }
      } else if (choosenOperation === t('COMMON.EDIT') && selectedObjectId) {
        response = await updatePhysician(selectedObjectId, object);
        if (response) {
          fetchPhysiciansInformation();
        }
      }
      closeDialog();
    } catch (error: any) {
      props._snackbarAcknowledgement(
        true,
        error?.response?.data?.message || t('COMMON.UPSERTERROR'),
        t('COMMON.ERRORTEXT')
      );
      closeDialog();
    }
  };

  const DeleteData = async (): Promise<void> => {
    try {
      closeDialog();
      const response = await deletePhysician(selectedObjectId);
      if (response) {
        fetchPhysiciansInformation();
      }
    } catch (error) {
      props._snackbarAcknowledgement(
        true,
        t('COMMON.DELETEERROR'),
        t('COMMON.ERRORTEXT')
      );
    }
    setSelectedObjectId();
    clearSelectedObject();
  };

  const renderDialog = (): ReactElement => {
    return (
      <Dialog
        open={isDialogVisible}
        onClose={closeDialog}
        aria-labelledby="form-dialog-title"
        maxWidth={'md'}
        fullScreen={fullScreen}
        className={classes.dialog}>
        <DialogContent>
          <div className="dialog-container">
            <div className="content-container">
              <div
                className={
                  'image-border-container ' +
                  (!selectedDataObject.profilePic && 'show')
                }>
                <label
                  htmlFor="icon-button-file"
                  className={
                    selectedDataObject.profilePic
                      ? 'image-hidden'
                      : 'image-label'
                  }>
                  {!selectedDataObject.profilePic && (
                    <IconButton component="span">
                      <PhotoCamera />
                    </IconButton>
                  )}
                </label>
                <input
                  accept="image/*"
                  id="icon-button-file"
                  type="file"
                  className="image-input"
                  onChange={uploadFile}
                />
                {selectedDataObject && selectedDataObject.profilePic && (
                  <img
                    alt="Logo"
                    src={selectedDataObject.profilePic}
                    className="image-container"
                  />
                )}
              </div>

              <div className="form-container">
                <div className="titile-container">
                  <div className="title-view">
                    <span className="title-text">
                      {choosenOperation +
                        ' ' +
                        t('INTERPRETINGPHYSICIANS.INTERPRETINGPHYSICIAN')}
                    </span>
                  </div>

                  <div className="close-view">
                    <Link
                      component="button"
                      variant="body2"
                      onClick={() => {
                        closeDialog();
                      }}>
                      <span className="close-view-text">
                        {t('PROCEDUREFLOWHEADER.CLOSE')}
                      </span>
                    </Link>
                  </div>
                </div>

                <div className="text-field-row-container">
                  <div className="input-label">
                    <span className="input-label-text">
                      {t('REGISTER.FIRST_NAME')}
                    </span>
                  </div>

                  <div className="text-field-container">
                    <TextField
                      id="outlined-textarea"
                      multiline
                      variant="outlined"
                      inputRef={firstNameRef}
                      required
                      className="text-field-input"
                      InputProps={{
                        className: classes.input
                      }}
                      defaultValue={selectedDataObject.firstName}
                    />
                  </div>
                </div>

                <div className="text-field-row-container">
                  <div className="input-label">
                    <span className="input-label-text">
                      {t('REGISTER.LAST_NAME')}
                    </span>
                  </div>

                  <div className="text-field-container">
                    <TextField
                      id="outlined-textarea"
                      multiline
                      variant="outlined"
                      inputRef={lastNameRef}
                      required
                      className="text-field-input"
                      InputProps={{
                        className: classes.input
                      }}
                      defaultValue={selectedDataObject.lastName}
                    />
                  </div>
                </div>

                <div className="text-field-row-container">
                  <div className="input-label">
                    <span className="input-label-text">{'Reader ID'}</span>
                  </div>

                  <div className="text-field-container">
                    <TextField
                      id="outlined-textarea"
                      type='number'
                      multiline
                      variant="outlined"
                      inputRef={readerIdRef}
                      required
                      className="text-field-input"
                      InputProps={{
                        className: classes.input
                      }}
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, ''); // remove non-digits
                      }}
                      defaultValue={selectedDataObject.readerId}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="bio-label">
              <span className="input-label-text">
                {t('INTERPRETINGPHYSICIANS.BIO')}
              </span>
            </div>

            <div>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={7}
                variant="outlined"
                placeholder="Bio"
                inputRef={bioRef}
                required
                className="text-area-input"
                InputProps={{
                  className: classes.textAreaInput,
                  inputProps: {
                    max: 2000
                  }
                }}
                defaultValue={selectedDataObject.bio}
              />
            </div>
          </div>
        </DialogContent>

        <DialogActions className="actions-container">
          {choosenOperation === t('COMMON.EDIT') && (
            <img
              alt="Trash"
              src={DeleteImage}
              onClick={DeleteData}
              className="delete-image"
            />
          )}
          <Button
            variant="contained"
            size="large"
            className={classes.saveButton}
            onClick={createOrUpdateData}>
            <span className="button-text">{t('TIMESTAMP.SAVEBUTTON')}</span>
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <div className="physicians-wrapper">
      <div className="physician-view">
        <div className="physicians-container">
          <div className="physicians-text">
            {t('INTERPRETINGPHYSICIANS.INTERPRETINGPHYSICIANS')}
          </div>
          {/* <div className="physicians-description-container">
            <span className="physicians-description-text">{title}</span>
          </div> */}
        </div>
        <div className="button-container">
          <Button
            variant="contained"
            size="large"
            className={classes.button}
            onClick={openDialog}>
            <span className="button-text">{t('COMMON.ADD')}</span>
          </Button>
        </div>
      </div>

      <div className={classes.root} style={{ marginLeft: '6%' }}>
        <MaterialTable
          icons={tableIcons}
          style={styleObject}
          onRowClick={handleRowClick}
          columns={columnsList}
          data={physiciansData}
          options={optionsObject}
        />
      </div>

      {renderDialog()}
    </div>
  );
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { _snackbarAcknowledgement })(
  InterpretingPhysicians
);